import { Col, Row, Form } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  ListOrdersFilter,
  ListOrdersTable,
} from '@components/Order/ListOrders';
import { Page500 } from '@containers/ErrorPages';
import { orderApi } from '@reducers/order';
import { profileApi } from '@reducers/profile/profile';

export const OpenOrders = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const profiles = profileApi.useGetForSelectQuery();
  const status = orderApi.useGetStatusesQuery();
  const isLoading = profiles.isLoading || status.isLoading || status.isFetching;
  const isError = profiles.isError || status.isError;
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <Formik
      enableReinitialize
      initialValues={{
        country: searchParams.get('country') || '',
        area: searchParams.get('area') || '',
        did: searchParams.get('did') || '',
        profile: searchParams.get('profile') || '',
        status: searchParams.get('status') || '',
      }}
      onSubmit={() => {}}
    >
      <Form as={Row}>
        <Col md={3}>
          <ListOrdersFilter
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
        <Col md={9}>
          <ListOrdersTable
            useData={orderApi.useGetOpenQuery}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            profilesData={profiles.data}
            orderStatuses={status.data}
            tableCardHeader="Open orders"
          />
        </Col>
      </Form>
    </Formik>
  );
};
